import {
    formatDayAtTime,
    formatMonthDay,
    formatUserTime,
    formatWeekDay,
    parse,
    OwaDate,
    differenceInSeconds,
} from 'owa-datetime';
import abbreviatedFormatDuration from 'owa-duration-formatter/lib/abbreviated';
import { RealTimeFlightUpdateActivityFeedItem } from '../service/ActivityFeedItem';
import { RealTimeFlightUpdateType } from '../service/RealTimeFlightUpdate';
import { getUserConfiguration } from 'owa-session-store';
import loc, { format } from 'owa-localize';
import { ActivityFeedCardDetails, ActivityCardLayoutType } from './feedCardPresentationDetails';
import { ControlIcons } from 'owa-control-icons';
import { ActivityType } from '../service/ActivityFeedStorageItem';
import {
    activityFeedRealTimeFlightNotificationCancelledTitle,
    activityFeedRealTimeFlightNotificationDelayTitle,
} from './activityFeedCard.locstring.json';
const styles = require('./feedCards.scss');

export function getRealTimeFlightUpdateCard(
    item: RealTimeFlightUpdateActivityFeedItem
): ActivityFeedCardDetails {
    if (item.payload) {
        let flightTime: OwaDate;
        let cardTitle = '';
        let subTitleStyle: any;
        let destinationCity =
            item.payload.ArrivalCityName == ''
                ? item.payload.ArrivalAirportIata
                : item.payload.ArrivalCityName;
        if (item.payload.Scenario == RealTimeFlightUpdateType.DepartureDelayed) {
            // As we get the time value in users timezone we dont need to convert it in another timezone, hence passing UTC
            let originalflightTime = parse(
                getUserConfiguration().UserOptions.TimeZone,
                item.payload.DepartureTimeUtc.toString()
            );
            flightTime = parse(
                getUserConfiguration().UserOptions.TimeZone,
                item.payload.UpdatedDepartureTimeUtc.toString()
            );
            const delayInSeconds = differenceInSeconds(flightTime, originalflightTime);
            const delayTime = abbreviatedFormatDuration(delayInSeconds, { maxUnits: 2 });
            cardTitle = format(
                loc(activityFeedRealTimeFlightNotificationDelayTitle),
                item.payload.FlightNumber,
                destinationCity,
                delayTime
            );
        } else if (item.payload.Scenario == RealTimeFlightUpdateType.Cancelled) {
            flightTime = parse(
                getUserConfiguration().UserOptions.TimeZone,
                item.payload.DepartureTimeUtc.toString()
            );
            cardTitle = format(
                loc(activityFeedRealTimeFlightNotificationCancelledTitle),
                item.payload.FlightNumber,
                destinationCity
            );
            subTitleStyle = styles.strikethrough;
        }

        const flightFormatTime = formatDayAtTime(
            formatWeekDay(flightTime) + ', ' + formatMonthDay(flightTime),
            formatUserTime(flightTime)
        );
        return {
            senderInfo: [{ name: item.payload.FlightNumber.split(' ')[0], emailAddress: '' }],
            internetMessageId: item.payload.InternetMessageId,
            cardTitle: cardTitle,
            timeStamp: item.timestamp,
            isSeen: item.isSeen,
            cardType: ActivityCardLayoutType.MultiTitleActivityCard,
            activityType: ActivityType.RealTimeFlightUpdate,
            cardIcon: ControlIcons.Warning,
            cardSubTitle1: flightFormatTime,
            cardSubTitle1CssStyle: subTitleStyle,
        } as ActivityFeedCardDetails;
    }
    return {} as ActivityFeedCardDetails;
}
